import React from "react";
import _moment from "moment";
import JsxParser from "react-jsx-parser";

const CustomCell = (props) => {
  const { cellTemplate, dataItem, formatDate, formatDateWithoutTimezone, profile, baseUrl } = props;

  if (typeof cellTemplate === "string" || dataItem.rygRule) {
    Object.keys(dataItem).map((key) => {
      try {
        if (typeof dataItem[key] === "string") {
          let tempParse = JSON.parse(dataItem[key]);
          dataItem[key] = tempParse;
        }
      } catch (err) {}
    });
    return (
      <JsxParser
        bindings={{
          item: dataItem,
          moment: _moment,
          formatDate: formatDate,
          formatDateWithoutTimezone: formatDateWithoutTimezone,
          profile,
          baseUrl,
        }}
        renderInWrapper={false}
        jsx={cellTemplate ? cellTemplate : dataItem.rygRule ? dataItem.rygRule : "<td></td>"}
      />
    );
  }
  if (typeof cellTemplate === "function") {
    return (
      <td>
        <div className="gridActions" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "space-evenly" }}>
          {cellTemplate(dataItem)}
        </div>
      </td>
    );
  }
};

export default CustomCell;
